module.exports = __webpack_public_path__ + "img/Alien_symbol_8.de4a4963.png";